module.exports = __webpack_public_path__ + "static/media/cluster.d8ef7d47.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/247/cluster.png
// module id = 739
// module chunks = 0